import { tabsAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers(parts.keys)

const variants = {
  dark0: helpers.definePartsStyle({
    tablist: {
      borderBottom: '1px solid #33333330',
    },
    tab: {
      pt: 0,
      pl: 0,
      pr: 4,
      fontSize: 'lg',
      color: 'white',
      fontWeight: 'light',
      borderBottom: '2px solid transparent',
      textShadow: '.2rem .2rem .5rem #333333aa',
      _selected: {
        borderBottom: '2px solid hsl(160, 20%, 30%)',
      },
    },
    tabpanel: {
      px: 0,
    },
  }),
}

export default helpers.defineMultiStyleConfig({ variants })
